import store from '../store'

export function getRoadmaps() {	
	
	const state = store.getState()
	return state.roadmaps
}

